import { render, staticRenderFns } from "./DataHistoryManagement.vue?vue&type=template&id=608f6466&scoped=true"
import script from "./DataHistoryManagement.vue?vue&type=script&lang=js"
export * from "./DataHistoryManagement.vue?vue&type=script&lang=js"
import style0 from "./DataHistoryManagement.vue?vue&type=style&index=0&id=608f6466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f6466",
  null
  
)

export default component.exports